(function () {
  const widget = document.querySelector('[data-assistant]');
  if (!widget) return;

  const questions = widget.querySelectorAll('.assistant-question');
  const tabs = widget.querySelectorAll('.assistant-tabs__tab');
  const result = widget.querySelector('[data-result]');

  const ajaxUrl = widget.dataset.ajaxUrl;
  const whatsapp = widget.dataset.whatsapp;
  const mapsLink = widget.dataset.mapsLink;
  const chatIcon = widget.dataset.chatIcon;
  const locationIcon = widget.dataset.locationIcon;
  const nonce = widget.dataset.nonce;

  const state = {};
  let step = 0;

  function renderStep() {
    questions.forEach((q, i) => { q.hidden = i !== step; });
    tabs.forEach((tab, i) => {
      tab.classList.toggle('is-active', i === step);
      tab.classList.toggle('is-done', i < step);
      tab.setAttribute('aria-selected', String(i === step));
    });
    result.hidden = true;
  }

  function selectOption(question, button) {
    question.querySelectorAll('.assistant-option').forEach((o) => o.classList.remove('is-selected'));
    button.classList.add('is-selected');

    state[question.dataset.field] = button.dataset.value;

    setTimeout(() => {
      if (step < questions.length - 1) {
        step += 1;
        renderStep();
      } else {
        fetchResult();
      }
    }, 220);
  }

  questions.forEach((question) => {
    question.querySelectorAll('.assistant-option').forEach((button) => {
      button.addEventListener('click', () => selectOption(question, button));
    });
  });

  function renderResult(data) {
    const productsBlock = data.productsHtml
      ? `
        <p class="assistant-result__eyebrow">Unidades disponíveis na loja</p>
        <div class="assistant-products">${data.productsHtml}</div>
      `
      : '';

    const consultMessage = encodeURIComponent(
      'Olá, o Assistente de Escolha STILL me recomendou uma empilhadeira. Gostaria de solicitar uma proposta.'
    );
    const consultLink = whatsapp ? `https://wa.me/${whatsapp}?text=${consultMessage}` : '#';

    result.innerHTML = `
      <span class="eyebrow">Recomendação personalizada</span>
      <h3 class="assistant-result__title">Com base nas suas respostas, recomendamos:</h3>
      <p class="assistant-result__category">${data.categoria}</p>
      <p class="assistant-result__description">${data.descricao}</p>
      ${productsBlock}
      <div class="assistant-why">
        <p class="assistant-why__title">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"/></svg>
          Por que seminova STILL?
        </p>
        <p class="assistant-why__desc">Nossas empilhadeiras seminovas passam por inspeção técnica completa, revisão de componentes críticos e garantia. Você tem a qualidade STILL com investimento reduzido.</p>
      </div>
      <div class="assistant-actions">
        <a class="btn btn--primary" href="${consultLink}" target="_blank" rel="noopener noreferrer">
          <img class="icon-invert" src="${chatIcon}" alt="" width="20" height="20">
          Falar com um Consultor STILL
        </a>
        ${mapsLink ? `
        <a class="btn btn--outline-dark" href="${mapsLink}" target="_blank" rel="noopener noreferrer">
          <img class="icon-invert" src="${locationIcon}" alt="" width="16" height="16">
          Visitar loja
        </a>` : ''}
        <button class="btn btn--outline" type="button" data-restart>Refazer</button>
      </div>
    `;

    result.querySelector('[data-restart]').addEventListener('click', restart);
  }

  function fetchResult() {
    questions.forEach((q) => { q.hidden = true; });
    tabs.forEach((tab, i) => {
      const isResult = i === tabs.length - 1;
      tab.classList.toggle('is-done', !isResult);
      tab.classList.toggle('is-active', isResult);
      tab.setAttribute('aria-selected', String(isResult));
    });
    result.hidden = false;
    result.innerHTML = '<p class="assistant-result__loading">Calculando recomendação...</p>';

    const body = new URLSearchParams({ action: 'still_assistant_recommend', nonce, ...state });

    fetch(ajaxUrl, { method: 'POST', body })
      .then((r) => r.json())
      .then((res) => {
        if (res.success) renderResult(res.data);
      })
      .catch(() => {
        result.innerHTML = '<p class="assistant-result__loading">Não foi possível calcular a recomendação. Tente novamente.</p>';
      });
  }

  function restart() {
    Object.keys(state).forEach((key) => delete state[key]);
    step = 0;
    widget.querySelectorAll('.assistant-option').forEach((o) => o.classList.remove('is-selected'));
    renderStep();
  }

  renderStep();
})();
